import {ColumnType, ColumnCode, ColumnZoomType} from 'priority-web-sdk/enums';

export const ColumnTypeMapping = {
    '0': ColumnType.Text,
    c: ColumnType.Text,
    s: ColumnType.Text,
    S: ColumnType.Text,
    b: ColumnType.Bool,
    r: ColumnType.Number,
    i: ColumnType.Number,
    d: ColumnType.Date,
    e: ColumnType.Date,
    D: ColumnType.Date,
    t: ColumnType.Time,
    T: ColumnType.Duration,
    y: ColumnType.Text,
    u: ColumnType.Number,
    o: ColumnType.Text
};

export const ColumnZoomTypeMapping = {
    0: ColumnZoomType.None,
    1: ColumnZoomType.Attach,
    2: ColumnZoomType.Search,
    3: ColumnZoomType.Choose,
    4: ColumnZoomType.Zoom,
    5: ColumnZoomType.Date14,
    6: ColumnZoomType.Date8,
    7: ColumnZoomType.Date10,
    8: ColumnZoomType.EMail,
    9: ColumnZoomType.URL,
    10: ColumnZoomType.HiddenZoom,
    11: ColumnZoomType.LinkFile,
    12: ColumnZoomType.QEdit,
    99: ColumnZoomType.SpecialAttach
};

export const ColumnCodeMapping = {
    '0': ColumnCode.None,
    c: ColumnCode.Char,
    s: ColumnCode.Str,
    S: ColumnCode.Rstr,
    b: ColumnCode.Bool,
    r: ColumnCode.Real,
    i: ColumnCode.Int,
    d: ColumnCode.Date8,
    e: ColumnCode.Date10,
    D: ColumnCode.Date14,
    t: ColumnCode.Time5,
    T: ColumnCode.Time6,
    y: ColumnCode.Day,
    u: ColumnCode.Unasigned,
    o: ColumnCode.Operator
};
